import React, { useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "../components/layout/PublicLayout";
import { api, formatApiError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!email) { toast.error("Please enter your email address"); return; }
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch(e) {
      toast.error(formatApiError(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PublicLayout>
      <div className="min-h-[70vh] flex items-center justify-center px-4">
        <Card className="w-full max-w-md p-8 border-border shadow-organic">
          {!sent ? (
            <>
              <div className="text-center mb-6">
                <div className="w-14 h-14 rounded-2xl bg-[#D0F5F2] flex items-center justify-center mx-auto mb-4">
                  <Mail size={24} className="text-[#2A9D8F]" />
                </div>
                <h1 className="font-display text-2xl font-bold tracking-tight">Forgot your password?</h1>
                <p className="text-sm text-muted-foreground mt-2">Enter your email and we will send you a reset link.</p>
              </div>
              <div className="space-y-4">
                <div>
                  <Label className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Email address</Label>
                  <Input type="email" value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.com" className="mt-1.5 h-11"
                    onKeyDown={e => e.key === "Enter" && handleSubmit()} />
                </div>
                <Button onClick={handleSubmit} disabled={submitting} className="w-full h-11 bg-[#2A9D8F] hover:bg-[#23887A]">
                  {submitting ? "Sending…" : "Send reset link"}
                </Button>
                <div className="text-center">
                  <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground flex items-center justify-center gap-1">
                    <ArrowLeft size={14} /> Back to sign in
                  </Link>
                </div>
              </div>
            </>
          ) : (
            <div className="text-center">
              <div className="w-14 h-14 rounded-2xl bg-[#D0F5F2] flex items-center justify-center mx-auto mb-4">
                <Mail size={24} className="text-[#2A9D8F]" />
              </div>
              <h1 className="font-display text-2xl font-bold tracking-tight">Check your inbox</h1>
              <p className="text-sm text-muted-foreground mt-2 mb-6">
                If <strong>{email}</strong> has an account, you will receive a password reset link shortly.
              </p>
              <Link to="/login" className="text-sm text-[#2A9D8F] font-semibold hover:underline flex items-center justify-center gap-1">
                <ArrowLeft size={14} /> Back to sign in
              </Link>
            </div>
          )}
        </Card>
      </div>
    </PublicLayout>
  );
}
